import axios from 'axios';
import { INTERACTIVE } from 'utils/constants';
import { trackPromise } from 'react-promise-tracker';
import { GetEngineInfoResponse, SapIntegrationTransactionExecuteResponse } from 'models/response';

/**
 * This API downloads the Lucystarter
 * @param {number} idUser
 * @return {Promise<AxiosResponse<string>>}
 */
const downloadLucyStarter = (idUser: number) =>
  trackPromise(axios.get<string>(`${INTERACTIVE}/downloadLucyStarter?idUser=${idUser}`), 'module');

/* This API is used to get the info for the engine */
const getEngineInfo = () => trackPromise(axios.post<GetEngineInfoResponse>(`${INTERACTIVE}/getEngineInfo`), 'module');

/* This is used to check if the service is running */
const isJiesRunning = (port: number) =>
  trackPromise(
    fetch(`http://localhost:${port}/welcome`, {
      method: 'GET',
    }),
    'module',
  );

/* This is used to kill the connection to jies */
const killJies = (port: number) =>
  trackPromise(
    fetch(`http://localhost:${port}/kill`, {
      method: 'GET',
    }),
    'module',
  );

/* This is used to check if the service is running */
const sapIntegrationTransactionExecute = (body: {
  port: number;
  data: {
    flowName: string;
    flowConfigRootType?: string;
    input: {
      idProtocol: number;
      idProgram: number;
    };
    parameters: {
      ID_USER: number;
      LOG_ENTITY_TYPE: string;
      LOG_ENTITY_ID: number;
      ID_COMPANY: number;
    };
  };
}): Promise<SapIntegrationTransactionExecuteResponse> =>
  trackPromise(
    fetch(`http://localhost:${body.port}/sap/integration/transaction/execute`, {
      body: JSON.stringify(body.data),
      headers: {
        Accept: 'application/json',
        'Content-Type': 'application/json',
      },
      method: 'POST',
    }).then((response) => response.json()),
    'leftBottom',
  );

/* This is used to save SAP login credentials of the user */
const sapSetCredentials = (body: {
  port: number;
  data: {
    environment: string;
    username: string;
    password: string;
    language: string | null;
  };
}) =>
  trackPromise(
    fetch(`http://localhost:${body.port}/sap/integration/transaction/setCredential`, {
      body: JSON.stringify(body.data),
      headers: {
        Accept: 'application/json',
        'Content-Type': 'application/json',
      },
      method: 'POST',
    }).then((response) => response.text()),
    'modal',
  );

export default {
  downloadLucyStarter,
  getEngineInfo,
  isJiesRunning,
  sapIntegrationTransactionExecute,
  sapSetCredentials,
  killJies,
};
